document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('custom-popup');
  const popup1 = document.querySelector('#custom_popup1'); // Replace with actual Popup 1 ID or class
  const popup2 = document.querySelector('#custom_popup2'); // Replace with actual Popup 2 ID or class
  
  const closeBtn = document.getElementById('close-popup');
  const triggerBtn = document.getElementById('custom_add_kits_btn');

  const nameInput = document.querySelector('#kits-name'); 
  const numberInput = document.querySelector('#kits-number'); 
  // const styleSelect = document.querySelector('#kits-jersey-style');

  const orderName = document.querySelector('#custom_popup2-kits-name'); 
  const orderInput = document.querySelector('#custom_popup2-kits-number'); 
  // const orderSelect = document.querySelector('#custom_popup2-kits-style'); 

  // Show Popup on Click
  triggerBtn.addEventListener('click', function (event) {

    event.preventDefault();
    popup.style.display = 'flex';
  });

  // Close Popup on Close Button Click
  closeBtn.addEventListener('click', function () {

    if (nameInput) nameInput.value = '';
    if (numberInput) numberInput.value = '';
    // if (styleSelect) styleSelect.selectedIndex = 0;

    if (orderName) orderName.textContent = '';
    if (orderInput) orderInput.textContent = '';
    // if (orderSelect) orderSelect.textContent = '';
    
    popup.style.display = 'none';
    popup1.style.display = 'block';
    popup2.style.display = 'none';
    
  });

  // Close Popup on Outside Click
  popup.addEventListener('click', function (event) {
    if (event.target === popup) {

      if (nameInput) nameInput.value = '';
      if (numberInput) numberInput.value = '';
      // if (styleSelect) styleSelect.selectedIndex = 0;
      
      if (orderName) orderName.textContent = '';
      if (orderInput) orderInput.textContent = '';
      // if (orderSelect) orderSelect.textContent = '';
      
      popup.style.display = 'none';
      popup1.style.display = 'block';
      popup2.style.display = 'none';
    }
  });

  const nextButton = document.querySelector('#custom_kits_submit_component');
  nextButton.addEventListener('click', function () {
    
    const nameValue = document.querySelector('#kits-name').value; 
    let numberValue = document.querySelector('#kits-number').value; 
    // const styleValue = document.querySelector('#kits-jersey-style').value;

    // Validate fields
    if (!nameValue) {
        alert("Please fill in the Name field.");
        return;
    }
    if (!numberValue) {
        // alert("Please fill in the Number field.");
        // return;
        numberValue = 'none';
    }
    // if (!styleValue) {
    //     alert("Please select a Jersey Style.");
    //     return;
    // }
  
    
    document.querySelector('#custom_popup2-kits-name').innerText = nameValue; 
    document.querySelector('#custom_popup2-kits-number').innerText = numberValue; 
    // document.querySelector('#custom_popup2-kits-style').innerText = styleValue;
  
    
    document.querySelector('#custom_popup2').style.display = 'block';
    document.querySelector('#custom_popup1').style.display = 'none';
  });

  const backToEditButton = document.querySelector('#back-to-edit-button'); // Replace with the actual button ID or class

  // Add click event listener to the "Back to Edit" button
  backToEditButton.addEventListener('click', function () {
      // Hide Popup 2
      popup2.style.display = 'none';

      // Show Popup 1
      popup1.style.display = 'block';
  });

  // Add to Cart Button
  const addToCartButton = document.querySelector('#custom_kits_add_cart');
  addToCartButton.addEventListener('click', function () {
    
    popup.style.display = 'none';
    popup1.style.display = 'block';
    popup2.style.display = 'none';

    // const custom_product_title = document.querySelector('#custom_popup2-kits-style').innerText;
    const custom_product_name = document.querySelector('#custom_popup2-kits-name').innerText;
    const custom_product_number = document.querySelector('#custom_popup2-kits-number').innerText;
    

    if(triggerBtn) {
      triggerBtn.innerHTML = 'Name & Number +$45 will appear in your cart';

      document.getElementById('custom_add_kits_btn').style.background = '#d3d3d3';
      document.getElementById('custom_add_kits_btn').style.color = '#22272D';
    }
    
  });

  const realToCartButton = document.querySelector('#AddToCart');
  realToCartButton.addEventListener('click', function (e) {

    // const custom_product_title = document.querySelector('#custom_popup2-kits-style').innerText;
    const custom_product_name = document.querySelector('#custom_popup2-kits-name').innerText;
    const custom_product_number = document.querySelector('#custom_popup2-kits-number').innerText;

    if (!custom_product_name) {
      console.log("Only added the Jersey product");
    }

    else {
      e.preventDefault();

      const mainProductValueID = document.querySelector('input[name="id"]').value;
      const mainProductValueName = document.querySelector('input[name="id_name"]').value;
      const mainProductValueSku = document.querySelector('input[name="id_sku"]').value;
      const mainProductValueSize = document.querySelector('input[name="selected_size"]').value;
      console.log('For Hypersonic', mainProductValueID, mainProductValueName, mainProductValueSku)

      let productId = 41905204461641;
      
      const quantity = 1; // Adjust the quantity if needed

      const properties = {
          Name: custom_product_name,
          Number: custom_product_number,
          // linked_main_product: mainProductValueID,
          Jersey: mainProductValueName,
          'Jersey Size': mainProductValueSize,
          'Jersey SKU': mainProductValueSku,
      };

      fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: mainProductValueID, quantity: 1 })
      })
      .then(response => response.json())
      .then(data => {
          console.log('Main product added:', data);
          const relatedProducts = [
              { id: productId, quantity: 1, properties: properties }
          ];
  
          relatedProducts.forEach(product => {
              fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(product)
              }).then(response => response.json())
                .then(data => {
                  
                  console.log('Related product added:', data);
                  // updateCartDrawer();

                  document.querySelector('#kits-name').value = ""; 
                  document.querySelector('#kits-number').value = ""; 
                  document.querySelector('#custom_popup2-kits-name').innerText = ""; 
                  document.querySelector('#custom_popup2-kits-number').innerText = "";

                  document.getElementById('custom_add_kits_btn').style.pointerEvents = 'auto';
                  document.getElementById('custom_add_kits_btn').style.background = '#22272D';
                  document.getElementById('custom_add_kits_btn').style.color = '#FFFFFF';
                  triggerBtn.innerHTML = 'ADD NAME & NUMBER - $45';
                  
                  updateCartCount();
                  updateCartDrawer();
                  
                })
                .catch(err => console.error(err));
          });
      })
      .catch(err => console.error('Error adding product:', err));
    }
    
    
  });
  

  // Function to update the cart count dynamically
  function updateCartCount() {
      fetch('/cart.js', {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json'
          }
      })
      .then(response => response.json())
      .then(cart => {
          const cartCountElement = document.querySelector('.header__cart-count'); // Adjust the selector for your cart count element
          if (cartCountElement) {
              cartCountElement.innerText = cart.item_count; // Update cart count
          }
        
      })
      .catch(error => {
          console.error('Error updating cart count:', error);
      });
  }

  function updateCartDrawer() {
    

    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Cart data:', cart);

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true, 
        detail: {
          cart: cart
        }
      }));
      
    })
    .catch(error => {
        console.error('Error updating cart drawer:', error);
    });
  }
  
});

document.addEventListener('cart:updated', function(event) {
  
  // var cart = event.detail.cart;
  
  // var productsWithParent = cart.items.filter(function(item) {
  //   return item.properties && item.properties.linked_main_product;
    
  // });

  // productsWithParent.forEach(function(item) {
  //   var parentProductId = item.properties.linked_main_product;
  //   console.log('Parent Product ID', parentProductId);
  //   cart.items.forEach(function(otherItem) {
  //     console.log('Product ID', otherItem.id);
  //     if (otherItem.id == parentProductId) {
  //       console.log("remove not working...");
  //     }
  //     else {
  //       console.log("remove working...");
  //     }
  //   });
  // });
  
});